<template>
	<div class="data-center" >
    <div class="carousel-container">
      <img src="@/assets/index/data/patIndex.png" style="width: 100%;height: 100%;">

    </div>

		<!-- <Carousel v-model="active" loop autoplay :autoplay-speed="5000" >
			<CarouselItem v-for="(item,i) in bannerData" :key='i'>
				<div class="carousel-container" @click="openUrl('http://fy.patentstar.com.cn')">
					<img :src="item.imgUrl" />
					<span class="carousel-title">
						{{item.title}}
					</span>
				</div>
			</CarouselItem>
		</Carousel> -->
		<Spin size="large" fix v-if="loading"></Spin>
	</div>

</template>

<script>
	//import {queryBannerData} from '@/api/presentation'
	export default {
		name: 'carouselist',
		data() {
			return {
				active: 0,
				loading:false,
				bannerData:[]
			};
		},
		created:function(){
			// this.queryBannerData();
		},
		methods:{
			// queryBannerData:function(){
			// 	this.loading = true;
			// 	queryBannerData().then(r=>{
			// 		this.bannerData = r.data;
			// 		this.loading = false;
			// 	});
			// },
			openUrl:function(url){
				window.open(url);
			}
		}
	}
</script>

<style scoped lang="scss">
	.data-center {
		border: 0px ;
		height: 355px;
	}
	.carousel-container {
		height: 355px;
		position: relative;
    overflow: hidden;
	}
	.carousel-container img{
		height: 355px;
		width: 100%;
	}

	.carousel-title{
		padding-left: 15px;
		isplay: block;
		position: absolute;
		bottom: 0px;
		right: 0px;
		background-color: rgba(60,60,60,0.7);
		width: 100%;
		line-height: 45px;
		font-size: 20px;
		color: white;
	}


</style>



// WEBPACK FOOTER //
// src/view/index/data/carouselist.vue